import { NavigationGuardNext, Route } from 'vue-router'

import store from '@/store'

function fetchBusinessTypesGuard(to: Route, from: Route, next: NavigationGuardNext): void {
  store.dispatch('businessTypes/FETCH_TYPES').finally(() => next())
}

export default fetchBusinessTypesGuard
